import { useEffect } from 'react';
import { AppMobile } from '@vfit/shared/data-access';
import { IUseNavBar } from './navBar.models';

export const useNavBar = ({ backInApp }: IUseNavBar) => {
  const isInApp = AppMobile.checkIsApp();

  useEffect(() => {
    if (isInApp && backInApp) {
      AppMobile.setBackButtonUrl(window.location.href);
    }
  }, [isInApp, backInApp]);

  return {
    isInApp,
  };
};

